"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Impact record converter.
 *
 * @author Radek Beran
 */


var ImpactRecordConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ImpactRecordConverter, _DataObjectConverter_);

  function ImpactRecordConverter() {
    _classCallCheck(this, ImpactRecordConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImpactRecordConverter).apply(this, arguments));
  }

  return ImpactRecordConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ImpactRecordConverter = ImpactRecordConverter;